// extracted by mini-css-extract-plugin
module.exports = {"copyTip":"CopyTip-module__copyTip___11em9","hidden":"CopyTip-module__hidden___KqqKn","visible":"CopyTip-module__visible___35N_R","fadeIn":"CopyTip-module__fadeIn___3d8-_"};